import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  plansListRequest: ['teamId'],
  plansListSuccess: ['listData'],
  plansListFailure: ['error'],

  plansUpdateRequest: ['id', 'updateParams'],
  plansUpdateSuccess: ['updateData'],
  plansUpdateFailure: ['updateError'],

  plansSetCurrentPlan: ['planId'],
  plansSetCurrentInterval: ['interval']
})

export const PlanTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  listData: [],
  fetching: null,
  error: null,

  updateData: [],
  updateFetching: null,
  updateError: null,

  currentPlan: {},
  currentInterval: 'yearly'
})

/* ------------- Reducers ------------- */

export const listRequest = (state) =>
  state.merge({ fetching: true, error: null })

export const listSuccess = (state, { listData }) => {
  return state.merge({ fetching: false, listData })
}

export const listFailure = (state, { error }) =>
  state.merge({ fetching: false, error })

export const setCurrentPlan = (state, { planId }) => {
  return state.merge({
    currentPlan: state.plans.find(plan => {
      return plan.id === planId
    }) || {}
  })
}

export const updateRequest = (state) =>
  state.merge({ updateFetching: true, updateError: null })

export const updateSuccess = (state, { updateData }) =>
  state.merge({ updateFetching: false, updateData })

export const updateFailure = (state, { updateError }) =>
  state.merge({ updateFetching: false, updateError })
  
export const setCurrentInterval = (state, { interval }) => {
  return state.merge({ currentInterval: interval })
}

export const reset = (state) => state.merge(INITIAL_STATE)

/* ------------- Selectors ------------- */

export const PlanSelectors = {
  plansList: state => state.plans.listData
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.PLANS_LIST_REQUEST]: listRequest,
  [Types.PLANS_LIST_SUCCESS]: listSuccess,
  [Types.PLANS_LIST_FAILURE]: listFailure,

  [Types.PLANS_UPDATE_REQUEST]: updateRequest,
  [Types.PLANS_UPDATE_SUCCESS]: updateSuccess,
  [Types.PLANS_UPDATE_FAILURE]: updateFailure,

  [Types.PLANS_SET_CURRENT_PLAN]: setCurrentPlan,
  [Types.PLANS_SET_CURRENT_INTERVAL]: setCurrentInterval

})



// WEBPACK FOOTER //
// ./src/Redux/PlanRedux.js